import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import NotifyHeader from "../components/common/headers/common/NotifyHeader";
import backend from "../api";
import { debounce } from "lodash";

const Notify = () => {
  const [showIcon, setShowIcon] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const fetchedOnceRef = useRef(false);

  const fetchNotifications = async () => {
    if (user && !fetchedOnceRef.current) {
      setLoading(true);
      try {
        const response = await backend.get("/notifications", {
          params: { notified_user: user.user._id, page: 1, limit: 10 },
        });

        const fetchedNotifications = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setNotifications(fetchedNotifications);
        fetchedOnceRef.current = true;

        if (fetchedNotifications.length === 0) {
          localStorage.setItem("notificationLength", JSON.stringify(0));
        } else {
          const numOfNotifs = localStorage.getItem("notificationLength")
            ? JSON.parse(localStorage.getItem("notificationLength"))
            : 0;

          if (numOfNotifs === 0) {
            setShowIcon(true);
            localStorage.setItem(
              "notificationLength",
              JSON.stringify(fetchedNotifications.length)
            );
          } else {
            setShowIcon(fetchedNotifications.length > numOfNotifs);
          }
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [user]);

  return (
    <li
      className="onhover-div mobile-cart"
      onMouseEnter={debounce(fetchNotifications, 300)} // Debounced function on hover
    >
      {showIcon && <div className="cart-qty-cls mr-3"></div>}
      <Link to={`${process.env.PUBLIC_URL}/notification`}>
        <img
          onClick={() => {
            localStorage.setItem(
              "notificationLength",
              JSON.stringify(notifications.length)
            );
            setShowIcon(false);
          }}
          src={`${process.env.PUBLIC_URL}/assets/images/icon/bell.png`}
          className="img-fluid mr-3"
          alt=""
        />
      </Link>
      <ul className="show-div shopping-cart" style={{ width: "450px" }}>
        <div className="buttons">
          <strong>
            <h4>Notifications</h4>
          </strong>
        </div>
        {loading ? (
          <li>
            <h5>Loading notifications...</h5>
          </li>
        ) : Array.isArray(notifications) && notifications.length > 0 ? (
          notifications.map((item, index) => (
            <NotifyHeader key={index} item={item} markAsRead={() => {}} />
          ))
        ) : (
          <li>
            <h5>Notifications are currently empty.</h5>
          </li>
        )}

        {notifications.length > 0 && !loading && (
          <div>
            <li>
              <div className="buttons">
                <Link
                  to={`${process.env.PUBLIC_URL}/notification`}
                  className="view-cart"
                >
                  View all Notifications
                </Link>
              </div>
            </li>
          </div>
        )}
      </ul>
    </li>
  );
};

export default Notify;
